import { Card, CardHeader, Body1Strong, Body2, Link } from '@fluentui/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

const NeedHelpSection : React.FC<any> = ({styles}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.helpSection}>
        <Card className={styles.helpCard}>
            <CardHeader
                header={<Body1Strong>{t('info.help.title', 'Need Help?')}</Body1Strong>}
            />
            <Body2>
                {t('info.help.description', 'If you encounter issues setting up your API keys or have questions about using this add-in:')}
                <ul className={styles.helpList}>
                    <li>
                        {t('info.help.checkDocs', 'Check the ')}
                        <Link 
                            href="https://platform.openai.com/docs/api-reference" 
                            target="_blank" 
                            rel="noopener noreferrer"
                        >
                            {t('info.help.openaiDocs', 'OpenAI API documentation')}
                        </Link>
                    </li>
                    <li>
                        {t('info.help.azureDocs', 'Review ')}
                        <Link 
                            href="https://learn.microsoft.com/azure/ai-services/openai/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                        >
                            {t('info.help.azureDocsLink', 'Azure OpenAI documentation')}
                        </Link>
                    </li>
                    <li>
                        {t('info.help.contact', 'Contact your IT administrator for enterprise setup assistance')}
                    </li>
                </ul>
            </Body2>
        </Card>
    </div>
  )
}

export default NeedHelpSection